module.exports = __webpack_public_path__ + "img/editing_4.cf8bba81.png";